export default "__VITE_ASSET__BWyAiyyL__"